export default function stateToggle() {
  const input = $('.js-state-toggle');
  input.on('change', function () {
    const target = $(this).data('target');
    const val = $(this).data('cond');
    const currentVal = $(this).val();
    if (target && val && currentVal !== null) {
      if (currentVal.trim() === val) {
        $(target).show();
        if($(target).find('select').length) {
          $(target).find('select').addClass('validate').prop('required', true)
          if($(target).find('select').val()) {
            $(target).find('select').addClass('is-ok');
          }
        } else {
          $(target).addClass('validate').prop('required', true)
          if($(target).val()) {
            $(target).addClass('is-ok');
          }
        }
      } else {
        $(target).hide();
        if($(target).find('select').length) {
          $(target).find('select').removeClass('validate').prop('required', false)
          if(!$(target).find('select').val()) {
            $(target).find('select').removeClass('is-ok');
          }
        } else {
          $(target).removeClass('validate').prop('required', false)
          if(!$(target).val()) {
            $(target).removeClass('is-ok');
          }
        }
        $(target).next('p.error').hide();
        $(target).find('option').eq(0).prop({ selected: true });
      }
    }
  });

  if (input.val()) {
    input.trigger('change');
  }
}
